/**
 * @readonly
 * @enum {string}
 */
export const serviceStatuses = {
  // Train Cancelled
  CANCELLED: 'CANCELLED',
  // One of the stations has been cancelled
  LIMITED_SERVICE: 'LIMITED_SERVICE',
  // Equipment Change
  SEATING_CHANGED: 'SEATING_CHANGED',
  // Default status
  UNAFFECTED: 'UNAFFECTED'
};

/**
 * @readonly
 * @enum {string}
 */
export const serviceStopStatuses = {
  // The train is arrived to station
  ARRIVED: 'ARRIVED',
  // The train is departed from station
  DEPARTED: 'DEPARTED',
  // No delays or cancellations are expected in terms of the schedule and train not arrived/departed yet.
  ON_TIME: 'ON_TIME',
  // Something has affected the train timetable
  EXPECTED: 'EXPECTED',
  // Station is not serviced on a commercial basis
  CANCELLED: 'CANCELLED'
};

/**
 * Extension of serviceStopStatuses where the status contains
 * additional information based on the other date fields in the model,
 * eg: in a situation where the arrival status is 'ARRIVED', and the actual
 * arrival date time is later than the commercial arrival date time,
 * the extendedServiceStopStatus would be 'ARRIVED_LATE'
 *
 * @readonly
 * @enum {string}
 */
export const extendedServiceStopStatuses = {
  ...serviceStopStatuses,
  ARRIVED_ON_TIME: 'ARRIVED_ON_TIME',
  DEPARTED_ON_TIME: 'DEPARTED_ON_TIME',
  ARRIVED_LATE: 'ARRIVED_LATE',
  DEPARTED_LATE: 'DEPARTED_LATE',
  ARRIVED_EARLY: 'ARRIVED_EARLY',
  DEPARTED_EARLY: 'DEPARTED_EARLY',
  // The train has arrived, it was expected to have arrived late, but there is no recorded arrival time
  ARRIVED_EXPECTED_LATE: 'ARRIVED_EXPECTED_LATE',
  // The train has departed, it was expected to have departed late, but there is no recorded departure time
  DEPARTED_EXPECTED_LATE: 'DEPARTED_EXPECTED_LATE',
  // The train has arrived, it was expected to have arrived early, but there is no recorded arrival time
  ARRIVED_EXPECTED_EARLY: 'ARRIVED_EXPECTED_EARLY',
  // The train has departed, it was expected to have departed early, but there is no recorded departure time
  DEPARTED_EXPECTED_EARLY: 'DEPARTED_EXPECTED_EARLY'
};

/**
 * Carriers
 *
 * @readonly
 * @enum {string}
 */
export const carriers = {
  // Eurostar
  ES: 'ES',
  // Eurostar Red
  ER: 'ER'
};

/**
 * Enumeration of market values.
 *
 * @readonly
 * @enum {string}
 */
export const market = {
  // United Kingdom - English.
  UK_EN: 'UK_EN',
  // United States - English.
  US_EN: 'US_EN',
  // France - French.
  FR_FR: 'FR_FR',
  // Belgium - French.
  BE_FR: 'BE_FR',
  // Belgium - English.
  BE_EN: 'BE_EN',
  // Belgium - Dutch.
  BE_NL: 'BE_NL',
  // Netherlands - Dutch.
  NL_NL: 'NL_NL',
  // Germany - German.
  DE_DE: 'DE_DE',
  // Rest of the World - English.
  RW_EN: 'RW_EN'
};

/**
 * News severity levels
 *
 * @readonly
 * @enum {string}
 */
export const newsSeverity = {
  NORMAL: 'NORMAL',
  MINOR: 'MINOR',
  MAJOR: 'MAJOR',
  CRITICAL: 'CRITICAL'
};

/**
 * Status of a news item's relation to a service.
 * Distinct from `serviceStatuses`
 *
 * @readonly
 * @enum {string}
 */
export const serviceNewsStatuses = {
  UNAFFECTED: 'UNAFFECTED',
  DELAYED: 'DELAYED',
  CANCELLED: 'CANCELLED',
  LIMITED_SERVICE: 'LIMITED_SERVICE',
  SEATING_CHANGED: 'SEATING_CHANGED'
};
